import { AxiosResponse } from 'axios'
import lodash, { rest } from 'lodash'
import moment from 'moment'

import { request } from '../../../../1stlog-ui/src/utils'
import { parseProducts } from '../../../../shipmetrics-shared/containers/OrderEntry/Products/utils'
import {
  TOrderEntryBackendProduct,
  TOrderEntryProduct,
  TOrderEntryProvider,
} from '../../../../shipmetrics-shared/containers/OrderEntry/types'

type TProductPayload = {}

async function requestProducts(
  payload: TProductPayload,
): Promise<Array<TOrderEntryProduct>> {
  const { data } = (await request({
    method: 'post',
    url: `/api/orderlist`,
    data: payload,
  })) as AxiosResponse<any>
  return parseProducts(data)
}

export default {
  id: 'standard',
  name: 'Kundenservices',
  requestProducts,
}
